import React from 'react';

// Custom Loader Component
// This component will render a pulsating placeholder for loading states.
const CustomLoader = ({ width = '100px', height = '20px' }) => {
  // CSS for the custom pulse animation
  // This is embedded here for self-containment, but in a larger project,
  // it might live in a dedicated CSS file (e.g., CustomLoader.css).
  const loaderStyles = `
    @keyframes pulse {
      0% { opacity: 0.6; }
      50% { opacity: 1; }
      100% { opacity: 0.6; }
    }
  `;

  return (
    <>
      {/* Inject custom loader styles */}
      <style>{loaderStyles}</style>
      <div
        className="custom-loader rounded bg-secondary bg-opacity-25" // Bootstrap classes for rounded corners and light grey background
        style={{ width, height, animation: 'pulse 1.5s infinite ease-in-out' }} // Inline style for animation
      ></div>
    </>
  );
};

export default CustomLoader;
